export var SteeringType;
(function (SteeringType) {
    SteeringType["LEFT_HAND_DRIVE"] = "LEFT_HAND_DRIVE";
    SteeringType["RIGHT_HAND_DRIVE"] = "RIGHT_HAND_DRIVE";
    SteeringType["MOTORCYCLE"] = "MOTORCYCLE";
    SteeringType["UNKNOWN"] = "UNKNOWN";
})(SteeringType || (SteeringType = {}));
//# sourceMappingURL=steeringType.js.map